import React from 'react'
import { Button, Grid, Paper, TextField } from '@mui/material'
import { Formik } from 'formik'
import { type LoginPayload, validateLoginPayload } from '../../../api/schema-dtos/AuthDomainDtos'
import { AuthenticationSource } from '../../../api/user/AuthenticationSource'
import ButtonLoadingComponent from '../../shared/components/ui-widgets/ButtonLoadingComponent'
import ErrorComponent from '../../shared/components/ui-widgets/ErrorComponent'
import { useAuth } from '../provider/AuthProvider'
import ForgotPasswordComponent from './ForgotPasswordComponent'

const LoginComponent: React.FC = () => {
  const { onLogin, loginLoading } = useAuth()

  const defaultForm: LoginPayload = {
    context: AuthenticationSource.WEB,
    password: '',
    emailAddress: ''
  }

  return (
    <>
      <Paper sx={{ p: 4 }}>

        <Formik
          initialValues={defaultForm}
          validationSchema={validateLoginPayload}
          validateOnBlur={false}
          validateOnChange={false}
          onSubmit={async (values, actions) => {
            await onLogin(values)
          }}
        >
          {formikProps => (
            <form
              autoComplete={'off'}
              autoCorrect={'off'}
              onSubmit={formikProps.handleSubmit}
            >
              <Grid container spacing={2}>
                {!(formikProps.isValid) && (
                  <Grid item md={12} sx={{ mt: 3 }}>
                    <ErrorComponent title={'Form validation error'} message={Object.values(formikProps.errors).join(', ')}/>
                  </Grid>
                )}
                <Grid item md={12} xs={12}>
                  <TextField
                    label={'Email Address'}
                    type={'email'}
                    variant="outlined"
                    sx={{ width: '100%' }}
                    placeholder={'Email Address'}

                    {...formikProps.getFieldProps('emailAddress')}

                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <TextField
                    label={'Password'}
                    type={'password'}
                    variant="outlined"
                    sx={{ width: '100%' }}
                    placeholder={'Password'}

                    {...formikProps.getFieldProps('password')}
                  />
                </Grid>
                <Grid item md={12} xs={12} sx={{ justifyContent: 'space-between', alignItems: 'center', display: 'flex' }} >
                  <Button
                    variant={'contained'}
                    type="submit"
                    sx={{ mr: 2 }}
                    disabled={loginLoading()}>
                    Login
                     {(loginLoading() && <ButtonLoadingComponent/>)}
                  </Button>

                  <ForgotPasswordComponent title={'Forgot Password'} />
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Paper>
    </>
  )
}

export default LoginComponent
